import { datadogRum } from '@datadog/browser-rum'
import type { SubmitFeedbackContext } from '@seen/request-types/submitFeedback'
import { useCallback } from 'react'
import { useSeenApi } from '#src/contexts/seen-api/useSeenApi.ts'
import { useMedplum } from '#src/hooks/useMedplum.ts'

// Returns a function that snapshots diagnostics for a feedback report: the
// Datadog session replay link + session/view IDs, the active trace id, the
// current page URL, and build metadata. Captured lazily at submit time so the
// replay link points at the session as it stood when the user reported.
export function useFeedbackTelemetry(): () => SubmitFeedbackContext {
  const { appVersion, appCommitSha } = useSeenApi()
  const medplum = useMedplum()

  return useCallback(() => {
    const internal = datadogRum.getInternalContext()
    return {
      url: window.location.href,
      appVersion,
      appCommitSha,
      userAgent: navigator.userAgent,
      traceId: medplum.traceId,
      datadogSessionId: internal?.session_id,
      datadogViewId: internal?.view?.id,
      datadogSessionReplayUrl: datadogRum.getSessionReplayLink(),
    }
  }, [appVersion, appCommitSha, medplum])
}
